/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_YesInputs */

const en_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const fr_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui`)
};

const de_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja`)
};

const it_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SÌ`)
};

const ru_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да`)
};

const es_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

const zh_cn2_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的`)
};

const ja_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい`)
};

const hi_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ`)
};

const pt_pt2_embed_captions_yes = /** @type {(inputs: Embed_Captions_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Embed_Captions_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_yes = /** @type {((inputs?: Embed_Captions_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_yes(inputs)
	if (locale === "de") return de_embed_captions_yes(inputs)
	if (locale === "it") return it_embed_captions_yes(inputs)
	if (locale === "ru") return ru_embed_captions_yes(inputs)
	if (locale === "es") return es_embed_captions_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_yes(inputs)
	if (locale === "ja") return ja_embed_captions_yes(inputs)
	if (locale === "hi") return hi_embed_captions_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_yes(inputs)
	return en_embed_captions_yes(inputs)
});